import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Box } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { OrderInfoPropType } from 'utils';

import styles from './OrderHistoryCard.module.scss';

const OrderHistoryCard = ({ orderInfo, name, details, vip, hasError, onClick, cmdUri }) => {
  const renderListItem = (key, value) =>
    cmdUri && key === 'client' ? (
      <Link to={`/clients/universal-profile/${cmdUri}/about`}>
        <span className={styles.orderCardListValueLink} data-testid={`orderInfo-value-${key}`}>
          {value}
        </span>
      </Link>
    ) : (
      <span data-testid={`orderInfo-value-${key}`}>{value}</span>
    );

  const list = Object.entries(orderInfo).map(([key, value]) => (
    <tr key={key} data-testid={`orderInfo-${key}`}>
      <td className={styles.orderCardListKey} data-testid={`orderInfo-key-${key}`}>
        {key}:
      </td>
      <td className={styles.orderCardListValue}>
        {renderListItem(key, value)}
        {key === 'order#' && vip && (
          <span className={styles.orderCardBadge}>
            NM<b>VIP</b>
          </span>
        )}
      </td>
    </tr>
  ));

  const cardClasses = cx(styles.orderCard, { [styles.orderCardBorder]: !details }, { [styles.hasError]: hasError });

  return (
    <Box className={cardClasses} onClick={onClick} role="link" tabIndex={0}>
      <div className={styles.orderCardList}>
        {name && (
          <div className={styles.orderCardClientName} data-testid="order-name">
            {name}
          </div>
        )}
        <table>
          <tbody>{list}</tbody>
        </table>
      </div>
    </Box>
  );
};

OrderHistoryCard.propTypes = {
  orderInfo: OrderInfoPropType,
  name: PropTypes.node,
  details: PropTypes.bool,
  hasError: PropTypes.bool,
  onClick: PropTypes.func,
  cmdUri: PropTypes.string,
};

OrderHistoryCard.defaultProps = {
  orderInfo: {},
  name: null,
  details: false,
  hasError: false,
  onClick: null,
};

export default OrderHistoryCard;
